{
  "$id": "module://grant",
  "title": "Grant",
  "description": "Shared field catalog for Grant Agreement and Grant Notice documents",
  "type": "object",
  "properties": {
    "grantDocumentName": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "required": true,
      "noBlank": true
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "adapterProps": { "rows": 4 }
    },
    "document": {
      "type": "file",
      "title": "Upload Documents",
      "widget": "file-upload",
      "required": true,
      "accept": ".pdf,.jpg,.jpeg,.png,.docx,.doc",
      "maxSize": 10485760,
      "fileUpload": {
        "multiple": false,
        "maxFiles": 1,
        "submit": {
          "selection": "first",
          "arrayKey": "document"
        }
      }
    },
    "planGrantDocumentId": {
      "type": "string",
      "title": "Plan Grant Document Id",
      "widget": "hidden"
    },
    "planId": {
      "type": "string",
      "title": "Plan Id",
      "widget": "hidden"
    },
    "documentType": {
      "type": "number",
      "title": "Document Type",
      "widget": "hidden"
    },
    "ADD_PLAN_GRANT_DOCUMENT_VERSION_FROM_UPLOAD": {
      "type": "action-button",
      "label": "Add Document",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "versionTable": {
      "type": "embedded-table",
      "schemaRef": "planGrantDocumentVersions",
      "title": "",
      "hideToolbar": true,
      "filter": {
        "Id": "#/properties/planGrantDocumentId"
      },
      "actionParamMap": {
        "planGrantDocumentId": "#/properties/planGrantDocumentId",
        "planId": "#/properties/planId"
      }
    }
  }
}
